export default __webpack_public_path__ + "static/media/football.be70ec9e.png";